import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Tag } from "primereact/tag";
import { ComplaintActionModel } from "../../models/complaints/complaint-model";
import { Toast } from "primereact/toast";

interface DataTableProps {
  data: ComplaintActionModel[];
  handlepagechange: (event: any) => void;
  pageNo: number;
  pageSize: number;
  totalRecordsCount: number;
}

const InternalComplaintActionDataTable: React.FC<DataTableProps> = ({
  data = [],
  handlepagechange = () => {},
  pageNo = 1,
  pageSize = 10,
  totalRecordsCount = 0,
}) => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);

  const formatDate = (dateString?: string) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getSeverityTag = (severity?: string) => {
    const map: Record<string, "info" | "warning" | "danger" | "success"> = {
      low: "info",
      medium: "warning",
      high: "danger",
      critical: "danger",
    };
    const severityKey = severity?.toLowerCase() || '';
    return <Tag value={severity || 'unknown'} severity={map[severityKey] || "info"} />;
  };

  const getStatusTag = (statusId?: number) => {
    const statusMap: Record<number, { label: string, severity: "info" | "warning" | "danger" | "success" }> = {
      1: { label: "New", severity: "warning" },
      2: { label: "In Progress", severity: "info" },
      3: { label: "Resolved", severity: "success" },
    };
    
    const status = statusMap[statusId || 1] || { label: "Unknown", severity: "info" };
    return <Tag value={status.label} severity={status.severity} />;
  };

  return (
    <div className="col-12">
      <Toast ref={toast} />
      <div className="card border-noround p-2">
        <DataTable
          value={data}
          paginator
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          first={(pageNo - 1) * pageSize}
          totalRecords={totalRecordsCount}
          rows={pageSize}
          stripedRows
          onPage={handlepagechange}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          emptyMessage="No internal complaint actions found"
        >
          <Column field="internalComplaintId" header="Complaint ID" sortable />
          <Column field="actionDate" header="Action Date" body={(row) => formatDate(row.actionDate)} sortable/>
          <Column field="actionDescription" header="Action Description" style={{ maxWidth: "200px", wordWrap: "break-word" }} />
          <Column field="correctiveAction" header="Corrective Action" style={{ maxWidth: "200px", wordWrap: "break-word" }}/>
          <Column field="preventiveAction" header="Preventive Action" style={{ maxWidth: "200px", wordWrap: "break-word" }}/>
          <Column field="remarks" header="Remarks" style={{ maxWidth: "200px", wordWrap: "break-word" }}/>
          <Column 
            field="severity" 
            header="Severity" 
            body={(row) => getSeverityTag(row.severity)} 
            sortable
          />
          <Column 
            field="statusId" 
            header="Status" 
            body={(row) => getStatusTag(row.statusId)} 
            sortable
          />
          <Column field="updatedByName" header="Action By" sortable/>
          <Column field="copqInRs" header="COPQ (₹)" body={(row) => row.copqInRs?.toFixed(2) || "0.00"} sortable/>
          {/* <Column field="customerName" header="Customer Name" sortable/> */}
          
        </DataTable>
      </div>
    </div>
  );
};

export default InternalComplaintActionDataTable;